import styles from "./founder.module.css"

export default function FounderStory() {
    return (
        <section className={styles.founder}>
            <div className={styles.container}>
                <div className={styles.storyContent}>
                    <h2 className={styles.title}>The Founder's Journey</h2>
                    <p className={styles.subtitle}>From Frustrated Gamer to Industry Disruptor</p>

                    <div className={styles.timeline}>
                        <div className={styles.timelineItem}>
                            <div className={styles.marker}>1</div>
                            <div className={styles.content}>
                                <h3>The Problem</h3>
                                <p>
                                    Gaurav Jadhav lived through lag, scams, overpriced "official" stores, and failed payments that never
                                    came back.
                                </p>
                            </div>
                        </div>

                        <div className={styles.timelineItem}>
                            <div className={styles.marker}>2</div>
                            <div className={styles.content}>
                                <h3>The Realization</h3>
                                <p>
                                    Instead of quitting, he realized thousands of gamers faced the same issues. The market needed a fair
                                    alternative.
                                </p>
                            </div>
                        </div>

                        <div className={styles.timelineItem}>
                            <div className={styles.marker}>3</div>
                            <div className={styles.content}>
                                <h3>The Solution</h3>
                                <p>
                                    Built a system that fixed everything gamers hated — direct partnerships with vendors, transparent
                                    pricing, instant delivery.
                                </p>
                            </div>
                        </div>

                        <div className={styles.timelineItem}>
                            <div className={styles.marker}>4</div>
                            <div className={styles.content}>
                                <h3>The Revolution</h3>
                                <p>
                                    Pixel Moon Store launched as the fairest gaming marketplace, proving that profit and player welfare
                                    aren't mutually exclusive.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.founderQuote}>
                    <blockquote>
                        "Gaming should never feel like a scam or a luxury — it should feel like power, progress, and pure fun."
                    </blockquote>
                    <p className={styles.attribution}>— Gaurav Jadhav, Founder</p>
                </div>
            </div>
        </section>
    )
}
